export const rails = {
  post: function(path, params, headers = {}) {
    const headers_default = {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    };

    const headers_merged = { ...headers_default, ...headers };

    return fetch(path, {
      method: 'POST',
      headers: headers_merged,
      body: JSON.stringify(params)
    });
  },
  get: function(path, params = {}, headers = {}) {
    const headers_default = {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    };

    const headers_merged = { ...headers_default, ...headers };

    const query_string = this.query_serialize(params);

    const full_path = query_string ? `${path}?${query_string}` : path;

    return fetch(full_path, {
      method: 'GET',
      headers: headers_merged
    });
  },
  // Custom query serializer compatible with Rails.
  query_serialize: function(params) {
    return Object
      .entries(params)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          if (value.length == 0) {
            return `${encodeURIComponent(key)}[]=`;
          }
          return value.map(v => `${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`).join('&');
        } else {
          return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        }
      })
      .join('&');
  }
};

